import { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { waitForGroupContext } from '@/lib/auth';
import { Button } from '@/shared/components/ui/button';
import { Loader } from '@/shared/components/ui/loader';

/** Renders its children once the session is in the group, which right after joining it can take a moment */
export function GroupContextGate({ groupId, children }: { groupId: string; children: ReactNode }) {
  const { status, refetch, isFetching } = useQuery({
    queryKey: ['session-context', groupId],
    queryFn: () => waitForGroupContext(groupId).then(() => true),
    retry: false,
    staleTime: Infinity,
    gcTime: 0,
  });

  if (status === 'success') return children;

  if (status === 'error' && !isFetching) {
    return (
      <div className="flex flex-col items-center gap-4 p-4 max-w-md mx-auto text-center">
        <p>Det tar längre tid än vanligt att förbereda gruppen.</p>
        <Button onClick={() => refetch()}>Försök igen</Button>
      </div>
    );
  }

  return <Loader message="Förbereder er grupp…" />;
}
